import React from 'react';
import { getColor } from 'core/utils';

const NoReviewsIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} {...props}>
		<g fill={getColor("lavender")} fillRule="evenodd">
			<path d="M15 4c-3.162 0-5.748 2.195-6.994 3.483C6.77 6.191 4.206 4 1 4H0v4c0 4.411 3.589 8 8 8s8-3.589 8-8V4h-1Z" />
			<path d="M8.012 4.768c1.005-.817 2.293-1.65 3.789-2.188C10.521 1.094 8.697.22 8.416.09a.997.997 0 0 0-.814-.007c-.115.05-2.065.917-3.41 2.485 1.516.536 2.812 1.376 3.82 2.2Z" />
		</g>
	</svg>
);

export default NoReviewsIcon;
